
import React from "react";
import styled from "styled-components";
import { Clock } from "../atoms/Clock";

export const Header = () => {
  return (
    <SContainer>
      <SBusStop>
        <SLi><SText> の り ば</SText></SLi>
        <SLi><SText>Bus Stop</SText></SLi>
      </SBusStop>
      <SDirection>
        <SLi><SText>方 面</SText></SLi>
        <SLi><SText>Direction</SText></SLi>
      </SDirection>
      <SRoute>
        <SLi><SText>系 統</SText></SLi>
        <SLi><SText>Route No.</SText></SLi>
      </SRoute>
      <SNext>
        <SLi><SText>先 発　1 s t.</SText></SLi>
        <SLi><SText>次 発　2 nd.</SText></SLi>
      </SNext>
      <SClock>
        <div>
          <SClockText><SText>現 在 時 刻</SText></SClockText>
          <SClockTime>
            <div><Clock /></div>
          </SClockTime>
        </div>
      </SClock>
      <SOpe>
        <SLi><SText>運 行</SText></SLi>
        <SLi><SText>Operator</SText></SLi>
      </SOpe>
    </SContainer>
  );
};

const SContainer = styled.div`
  display: flex;
  align-items: flex-end;
  height: 59px;
  border: 1px solid;
  font-size: 21px;
  letter-spacing: -2px;

  border-left: transparent;
  border-right: transparent;
  border-top: transparent;
`;

const SBase = styled.div`
  color: #003676;
`;

const SLi = styled.div`
  height: 25px;
  position: relative;
`;

const SText = styled.div`
  width: 100%;
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
`

const SBusStop = styled(SBase)`
  width: calc(100px - 5px);
  padding-left: 5px;
  text-align: left;
`;
const SDirection = styled(SBase)`
  width: calc(100px - 30px);
  padding-right: 30px;
`;
const SRoute = styled(SBase)`
  width: 100px;
`;
const SNext = styled(SBase)`
  text-align: left;
  margin-left: 10px;
  width: calc(100% - 530px);
`;

const SClock = styled(SBase)`
  width: 100px;
`;

const SOpe = styled(SBase)`
  width: 120px;
`;

const SClockText = styled.div`
  height: 25px;
  position: relative;
  font-size: 21px;
`;
const SClockTime = styled.div`
  height: 40px;
  position: relative;
  letter-spacing: 1px;
  font-size: 30px;
  div {
    width: 100%;
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
  }
`;
